import React from 'react';
import './Tornado.css';

const Tornado = ({ color = '#26B1D4' }) => {
  return (
    <div className="tornado">
      {Array.from({ length: 100 }).map((_, i) => (
        <div key={i} className="punto" style={{ backgroundColor: color }}></div>
      ))}
    </div>
  );
};

export default Tornado;
